<template>
    <div style="position: relative;">
        <div style="position: absolute; right: 10px; top: 10px; z-index: 1000;">
            <StatusHelper :outlined="false" />
        </div>
        <Leaflet v-if="plan && traps" :plan="plan" full-height v-model="location" :traps="traps" />
        <v-layout v-else justify-center align-center style="height: 100%; width: 100%;" mt-4>
            <v-progress-circular :size="80" color="primary" indeterminate></v-progress-circular>
        </v-layout>
    </div>
</template>
<script>
import Leaflet from "@/components/Leaflet"
import StatusHelper from "@/components/StatusHelper"
import loadingMixin from "@/mixins/loading"

export default {
    mixins: [loadingMixin],
    components: {
        Leaflet,
        StatusHelper,
    },
    data() {
        return {
            location: null,
        }
    },
    beforeDestroy() {
        this.$apollo.queries.traps.stopPolling()
    },
    apollo: {
        plan: {
            query: require("@/graphql/plan/plan.gql"),
            variables() {
                return {
                    _id: this.$route.params.id,
                }
            },
            skip() {
                return !this.activated
            },
        },
        traps: {
            query: require("@/graphql/trap/traps.gql"),
            pollInterval: 20000,
            variables() {
                return {
                    plan: this.$route.params.id,
                }
            },
            skip() {
                return !this.activated
            },
        },
    },
}
</script>
<style lang="scss">
.leaflet-container {
    z-index: 0;
    height: calc(100vh - 64px);
    width: 100%;
    @media only screen and (max-width: 900px) {
        height: calc(100vh - 58px);
    }
}
</style>
